import type { ValueOf } from '#layers/base/public';

/** How much room the listing header has, measured against its own width; each tier sheds lower-priority chrome. */
export const ListingHeaderLayouts = {
	/** View tabs, full labels, and the optional icon and description all fit. */
	Wide: 'wide',
	/** Views condense into one menu. */
	Compact: 'compact',
	/** The icon and description drop out, controls shed their labels, and an opened search covers the header instead of growing in place. */
	Narrow: 'narrow',
} as const;

export type ListingHeaderLayout = ValueOf<typeof ListingHeaderLayouts>;
